// Theme.js version 1.0.1
// Use PrePros's Concat Js option to automatically prepend global.js at the beginning of this file.
// @prepros-prepend global.js

// Place any custom Javascript or jQuery in this file.
// If code needs to wait until the DOM is ready, place within the jQuery function below.
(function ($) {
	// Variables and DOM Caching.
	var $window = $(window),
		$body = $("body"),
		$menu = $(".nav-global"),
		$menuPanel = $(".menu-panel.agcentric-custom"),
		$menuToggle = $(".agcentric-custom .menu-close"),
		$menuToggle2 = $("#top-menu-custom .close-menu"),
		$menuReturn = $(".menu-return"),
		$menuLinks = $menu.find("li"),
		$menuDefaultActive = $(
			"#menu-item-90 > a, #menu-item-93 > a, #menu-item-133 > a, #menu-item-123 > a"
		),
		$angleHovers = $(
			".angle-hover, .nav-global > li > a, .nav-global > li > .sub-menu > li > a"
		),
		$menuSubsT1 = $(".nav-global > li.menu-item-has-children > a"),
		$menuSubsT2 = $(
			".nav-global > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > a"
		),
		$topHeader = $("#top_header > .navbar");

	// Initialize the ScrollTrigger extension for GSAP
	gsap.registerPlugin(ScrollTrigger);

	// Set up basic class-based animations to activate on scroll
	gsap.utils.toArray(".anim-out").forEach((section, i) => {
		gsap.to(section, {
			scrollTrigger: {
				trigger: section,
				start: "top center+=200px",
				end: "bottom bottom",
				once: true,
				toggleClass: { targets: section, className: "anim-in" },
			},
		});
	});

	// Adds onscroll to all Gutenberg elements
	$(".onscroll-hidden").removeClass("onscroll-hidden"); // Removed w/ JS to swap opacity back to 0, just in case JS is disabled
	gsap.utils.toArray(".content-area_gutenberg > *").forEach((section, i) => {
		$(section).addClass("in-from-bottom anim-out");
		gsap.to(section, {
			scrollTrigger: {
				trigger: section,
				start: "top center+=200px",
				end: "bottom bottom",
				once: true,
				toggleClass: { targets: section, className: "anim-in" },
			},
		});
	});

	/*
	// Refire parallax calculation in case height changes
	$('.site-wrap').imagesLoaded( function() {
		if (typeof parallaxDetails === "function") {
			onResize(parallaxDetails);
		}
	});
	*/

	// Use scrollTo.js to animate banner button scrolling.
	/*
	$('.hero-banner .btn').click(function(e) {
		if (e.currentTarget.hash) {
			e.preventDefault();

			$(window).scrollTo(e.currentTarget.hash, {duration: 600});
		}
	});
	*/

	$menuDefaultActive.addClass("activated");

	$menuToggle.click(function () {
		$body.removeClass("menu-open");

		$menuPanel.removeClass("active-tier-1 active-tier-2");
		$menuSubsT1.removeClass("activated");
		$menuSubsT2.removeClass("activated");
		$menuDefaultActive.addClass("activated");
	});

	$menuToggle2.click(function () {
		$body.removeClass("menu-open");

		$menuPanel.removeClass("active-tier-1 active-tier-2");
		$menuSubsT1.removeClass("activated");
		$menuSubsT2.removeClass("activated");
		$menuDefaultActive.addClass("activated");
	});

	$menuReturn.click(function () {
		if ($menuPanel.hasClass("active-tier-2")) {
			$menuSubsT2.removeClass("activated");
			$menuPanel.removeClass("active-tier-2");
		} else if ($menuPanel.hasClass("active-tier-1")) {
			$menuSubsT1.removeClass("activated");
			$menuSubsT2.removeClass("activated");
			$menuPanel.removeClass("active-tier-1");
		}
	});

	$(".nav-global > li.menu-item-has-children > a").click(function (e) {
		e.preventDefault();

		$menuPanel.addClass("active-tier-1");
		$menuSubsT1.removeClass("activated");
		$menuSubsT2.removeClass("activated");
		$(this).addClass("activated");
	});

	$(".nav-global > li > .sub-menu > li.menu-item-has-children > a").click(
		function (e) {
			e.preventDefault();

			$menuPanel.addClass("active-tier-1");
			$menuPanel.addClass("active-tier-2");
			$menuSubsT2.removeClass("activated");
			$(this).addClass("activated");
		}
	);

	$angleHovers
		.prepend(
			'<span class="ah-top ah-left"></span><span class="ah-top ah-right"></span>'
		)
		.append(
			'<span class="ah-bottom ah-left"></span><span class="ah-bottom ah-right"></span>'
		);

	var nav = $("#top-custom-menu > .menu-item-has-children"),
		links = nav.children("a");

	links.click(function (e) {
		e.preventDefault();

		if ($(this).parent().hasClass("active")) {
			$(this).parent().removeClass("active");
		} else {
			nav.removeClass("active");
			$(this).parent().toggleClass("active");
		}
	});

	$(".close-menu").click(function (e) {
		e.preventDefault();

		$body.removeClass("menu-open");

		return false;
	});
})(jQuery);
